import React from 'react';
import styles from './PreloadAnimation.module.css'; // Make sure to create this CSS module

interface PreloadAnimationProps {
    firstName: string;
    lastName: string;
}

const PreloadAnimation: React.FC<PreloadAnimationProps> = ({ firstName , lastName}) => {
    return (
        <div className={styles.container}>
            <h1 className={styles.animateText}>{firstName}</h1>
            <h2 className={styles.animateText}>x</h2>
            <h1 className={styles.animateText}>{lastName}</h1>
            {/* You can add more animated elements here */}
        </div>
    );
};

export default PreloadAnimation;
